<template>
    <div class="Login">
      <div class="hello-text">
        <div class="language-switch">
          <el-switch
            v-model="isEnglish"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="English"
            inactive-text="中文"
            @change="switchLanguage">
          </el-switch>
        </div>
      </div>
        <div class="num1">
            <div class="num1-i">
                <div class="num2-1">
                  <div><img src="@/views/Login/img/num5.png" alt=""></div>
                  <div class="tosiz">{{ $t('login.欢迎使用') }}</div>
                </div>

                <div class="num2-2">
                  <div class="num2-2-1" :style="$i18n.locale === 'en' ? 'font-size: 18px' : ''">{{ $t('login.智慧运维平台') }}</div>

                  <el-form :model="formInline" ref="loginFormRef" :rules="loginFormRules">
                      <el-form-item prop="username">
                        <div class="num2-2-2">
                          <img src="@/views/Login/img/num3.png" alt="">
                          <el-input v-model.trim="formInline.username" :placeholder="$t('login.请输入账户名称')"></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item prop="password">
                        <div class="num2-2-3">
                          <img src="@/views/Login/img/num4.png" alt="">
                          <el-input v-model.trim="formInline.password" :placeholder="$t('login.请输入登录密码')" show-password></el-input>
                        </div>
                      </el-form-item>

                  </el-form>
                  <div class="num2-2-4">
                      <el-button @click.native.prevent="handleLogin">{{ $t('login.登录') }}</el-button>
                  </div>
                </div>

            </div>

            <div class="num1-img">
                <img src="@/views/Login/img/num2.png" alt="">
            </div>

        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { mergeMenuConfig } from '@/utils/menuConfig'
export default {
  data () {
    return {
      isEnglish: false,
      goodsForeNo: null,
      MenuConfigtoken: {
        token: null
      },
      formInline: {
        username: '',
        password: ''
      },
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: this.$t('login.请输入登录名称'), trigger: 'blur' },
          { min: 1, max: 10, message: this.$t('login.长度在1到10个字符'), trigger: 'blur' }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: this.$t('login.请输入登录密码'), trigger: 'blur' },
          { min: 5, max: 15, message: this.$t('login.长度在5到15个字符'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 获取本地存储的语言设置，如果有的话
    const savedLanguage = localStorage.getItem('language')
    if (savedLanguage) {
      this.isEnglish = savedLanguage === 'en'
      this.$i18n.locale = savedLanguage
    }
  },
  watch: {
    // 添加对i18n.locale的监听
    '$i18n.locale': {
      handler (newVal) {
        // 当语言变更时，触发组件更新
        this.$forceUpdate()
        // 更新验证规则中的提示信息
        this.updateRules()
      },
      immediate: true
    }
  },
  methods: {
    // 语言切换方法
    switchLanguage (val) {
      const lang = val ? 'en' : 'zh'
      this.$i18n.locale = lang
      localStorage.setItem('language', lang) // 保存语言设置到本地存储
      // 触发组件重新渲染
      this.$forceUpdate()
      console.log('语言已切换为:', lang)
    },
    ...mapMutations(['handleLogin']),
    handleLogin () {
      this.$refs.loginFormRef.validate(valid => {
        console.log(valid, 'valid')
      })
      this.$api.lonig.Logins(this.formInline).then((res) => {
        console.log(res, '登录')
        if (res.data.status === 'success') {
          window.sessionStorage.setItem('token', res.data.data.token)
          this.goodsForeNo = res.data.data
          this.$store.commit('print/STORE_GOODSFORENO', this.goodsForeNo)
          // 登录成功后先获取菜单配置并存入 Vuex，再跳转到首页
          this.MenuConfigtoken.token = res.data.data.token
          this.$api.lonig.getMenuConfig(this.MenuConfigtoken).then((menuRes) => {
            console.log(menuRes, '左侧菜单数据')
            if (menuRes && menuRes.data && menuRes.data.status === 'success') {
              // 接口返回结构: { status, data: [ ... ] }；旧配置自动补全缺失菜单（如用量统计）
              const config = mergeMenuConfig(menuRes.data.data)
              this.$store.commit('print/STORE_MENU_CONFIG', config)
            }
            this.$router.push({ path: '/users' })
          }).catch(err => {
            console.error('获取菜单配置失败', err)
            this.$router.push({ path: '/users' })
          })
          console.log('登录成功获取左侧菜单数据')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 更新验证规则中的提示信息
    updateRules () {
      this.loginFormRules = {
        username: [
          { required: true, message: this.$t('login.请输入登录名称'), trigger: 'blur' },
          { min: 1, max: 10, message: this.$t('login.长度在1到10个字符'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('login.请输入登录密码'), trigger: 'blur' },
          { min: 5, max: 15, message: this.$t('login.长度在5到15个字符'), trigger: 'blur' }
        ]
      }
    }
  }
}
</script>
<style lang="less" scoped>

.Login{
    width: 100%;
    height: 100vh;
    background: url(../../views/Login/img/num1.png) no-repeat;
     position: fixed;
     background-size: 100% 100%;
     display: flex;
     justify-content: center;
     align-items: center;
     .hello-text {
         position: absolute;
         top: 20px;
         right: 30px;
         color: #fff;
         font-size: 16px;
         z-index: 999;
     }
     .num1{
         border-radius: 10px;
         background-color: #fff;
         display: flex;
         justify-content: space-between;
         .num1-i{
             width: 50%;
             .num2-1{
                 width: 200px;
                 color: rgb(94, 90, 90);
                 padding: 20px 20px;
                 img{
                     width: 150px;
                 }
                 .tosiz{
                     margin-top: 10px;
                     font-size: 13px;
                     letter-spacing: 0.5em;
                 }
             }
             .num2-2{
                 width: 270px;
                 margin: 0 auto;
                 .num2-2-1{
                     margin-top: 20px;
                     width: 100%;
                     font-size: 30px;
                     color: #555;
                     letter-spacing: 0.5em;
                     text-align: center;
                 }
                 .num2-2-2{
                     margin-top: 40px;
                     width: 100%;
                     font-size: 10px;
                     color: #555;
                     letter-spacing: 0.5em;
                     text-align: center;
                     display: flex;
                     align-items: center;
                     img{
                         width: 30px;height: 30px;margin-right: 10px;
                     }
                 }
                 .num2-2-3{
                     margin-top: 30px;
                     width: 100%;
                     font-size: 10px;
                     color: #555;
                     letter-spacing: 0.5em;
                     text-align: center;
                     display: flex;
                     align-items: center;
                     img{
                         width: 30px;height: 30px;margin-right: 10px;
                     }
                 }
                 .num2-2-4{
                   margin-top: 80px;
                     font-size: 10px;
                     color: #555;
                     letter-spacing: 0.5em;
                     text-align: center;
                     .el-button{
                         width: 200px;
                         background-color: #744DFE;
                         color: #fff;
                     }
                 }
             }
         }

         .num1-img{
             width: 50%;
             img{
                width: 100%;
                height: 100%;
             }
         }
     }
}
  @media (max-width: 768px) {
    .num2-1{
      display: none;
    }
    .num1-img{
      display: none;
    }
     .Login{
      background: none;
    }
  }
</style>
